/**
 * @file 注册页、落地页
 */
import { useRouter } from '@/router/router-standard'
import { trackEvent } from '@/utils/event-lib'
import useHooks from '@/views/maintenance/controller'
import $ from 'zepto'
import MaintenancePage from '@/views/maintenance/pure-html'
import { ACTION_TYPE } from '@/types/landing-page'

const buildAction = (action: ACTION_TYPE) =>
  +action > 1 ? `data-action="${action}"` : ''
const buildURL = (url: string) =>
  url ? `data-url="${url}"` : ''

export const buildImage = (item: ITEM) =>
  `<img 
      ${item.appendAttrs || ''}
      style="display:block"
      width="100%"
      src="${item.pic}"
      class="${item.isBottom ? 'is-bottom' : ''}"
      ${buildAction(item.action)}
      ${buildURL(item.url)}
    />`

/**
 * 绑定data-action事件
 * @param event
 * @returns false => 命中 打开app 或 跳转落地页 或 跳转链接
 * @returns DOMStringMap => 其他，由调用方处理
 */
export const onDelegate = (target: HTMLElement) => {
  const { action, url } = target.dataset
  // 打开app
  if (action === ACTION_TYPE.OPEN_APP) {
    useHooks().openApp()
    return false
  }
  // 跳转到注册页
  if (action === ACTION_TYPE.OPEN_REGISTER_PAGE) {
    trackEvent('fin_loan_abroad_outcast_h5_landing_page_ck')
    const $router = useRouter()
    $router?.push('/register')
    return false
  }
  if (action === ACTION_TYPE.OPEN_REGISTER_PAGE) {
    location.href = url as string
    return false
  }
  return target.dataset
}

/**
 * 默认维护页面
 */
export const renderMaintenancePage = (stage = 'default') =>
  $('#root').html(MaintenancePage.template(stage))
